class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    handleFloCartBtn(); return; // Shopflo: intercept cart open

    /* === Original open() body — commented out by Shopflo integration ===
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (!containerToTrapFocusOn) return;
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    === end original body === */
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    // Remove is-empty from cart-drawer itself
    this.classList.remove('is-empty');

    fetch(`${window.location.pathname}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        // Update cart-drawer-items
        const newCartItems = html.querySelector('cart-drawer-items');
        const existingCartItems = this.querySelector('cart-drawer-items');
        if (newCartItems && existingCartItems) {
          existingCartItems.innerHTML = newCartItems.innerHTML;
        }

        // Update drawer footer
        const newFooter = html.querySelector('.drawer__footer');
        const existingFooter = this.querySelector('.drawer__footer');
        if (newFooter && existingFooter) {
          existingFooter.innerHTML = newFooter.innerHTML;
        }

        // Remove is-empty from cart-drawer-items
        const cartDrawerItems = this.querySelector('cart-drawer-items');
        if (cartDrawerItems) cartDrawerItems.classList.remove('is-empty');

        // ← FIX: Hide the "Your cart is empty" div so product content is visible
        const innerEmpty = this.querySelector('.drawer__inner-empty');
        if (innerEmpty) innerEmpty.style.display = 'none';

        // Update cart icon bubble
        if (parsedState.sections && parsedState.sections['cart-icon-bubble']) {
          const bubbleHTML = new DOMParser().parseFromString(
            parsedState.sections['cart-icon-bubble'],
            'text/html'
          );
          const newBubble = bubbleHTML.querySelector('.shopify-section');
          const existingBubble = document.getElementById('shopify-section-cart-icon-bubble');
          if (newBubble && existingBubble) {
            existingBubble.innerHTML = newBubble.innerHTML;
          }
        }

        setTimeout(() => {
          const overlay = this.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', this.close.bind(this));
          this.open();
        });
      })
      .catch((e) => {
        console.error('Cart drawer fetch error:', e);
      });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);